import { Colors } from '@auteco/theme'
import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    root: {
        margin: '15px',
        '& .MuiAutocomplete-tag': {
            display: 'none',
        },
    },
    container: {
        width: '100%',
        maxWidth: '400px',
        position: 'relative',
        '&:hover button': {
            display: 'flex',
        },
    },
    button: {
        position: 'absolute',
        padding: '6px',
        zIndex: 2,
        top: '4px',
        display: 'none',
        right: 0,
        background: '#C9CCD1',
        color: '#5A5A5A',
        fontWeight: 'bold',
        cursor: 'pointer',
        borderRadius: '4px',
    },
    valueRendered: {
        position: 'absolute',
        height: '52px',
        top: '-44px',
        left: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
    },
    buttonSelectAll: {
        position: 'absolute',
        height: '26px',
        top: '-32px',
        right: '4px',
        fontSize: '12px',
        // backgroundColor: '#35465c',
        // color: 'white',
        backgroundColor: '#F0F0F0',
        border: `2px solid ${Colors.DARK_BLUE}`,
        color: Colors.DARK_BLUE,
        '&:hover': {
            backgroundColor: '#F0F0F0',
            border: `2px solid ${Colors.DARK_BLUE}`,
        },
    },
    containerChipsScroll: {
        overflowY: 'scroll',
        maxHeight: '100px',
        display: 'flex',
        flexWrap: 'wrap',
        width: '600px'
    }
}))